export const PEDIDO_VOO_STATUS = {
  AGUARDANDO_VALIDACAO: {
    id: 'AGUARDANDO_VALIDACAO',
    label: 'Aguardando Aprovação',
  },
  VALIDADO: {
    id: 'VALIDADO',
    label: 'Aprovação',
  },
  INVALIDADO: {
    id: 'INVALIDADO',
    label: 'Negado',
  },
  EXPIRED: {
    id: 'EXPIRED',
    label: 'Expirado',
  },
};

/** Status que podem ser definidos via PATCH /status (nunca AGUARDANDO_VALIDACAO). */
export const PEDIDO_VOO_STATUS_TARGETS = ['VALIDADO', 'INVALIDADO', 'EXPIRED'];

const FORBIDDEN_TARGETS = ['AGUARDANDO_VALIDACAO'];

const TRANSITION_MATRIX = {
  AGUARDANDO_VALIDACAO: ['VALIDADO', 'INVALIDADO', 'EXPIRED'],
  VALIDADO: ['INVALIDADO', 'EXPIRED'],
  INVALIDADO: ['VALIDADO', 'EXPIRED'],
  EXPIRED: ['VALIDADO', 'INVALIDADO'],
};

export const canTransitionTo = (fromStatus, toStatus) => {
  if (!fromStatus || !toStatus || fromStatus === toStatus) return false;
  if (FORBIDDEN_TARGETS.includes(toStatus)) return false;
  const allowed = TRANSITION_MATRIX[fromStatus];
  return Array.isArray(allowed) && allowed.includes(toStatus);
};

export const getAvailableStatusActions = (currentStatus) => {
  if (!currentStatus) return [];
  return TRANSITION_MATRIX[currentStatus] || [];
};

export const PEDIDO_VOO_STATUS_OPTIONS = Object.values(PEDIDO_VOO_STATUS).map(
  ({ id, label }) => ({ id, nome: label })
);

export const PEDIDO_VOO_STATUS_FILTER_OPTIONS = PEDIDO_VOO_STATUS_OPTIONS.map(
  ({ id, nome }) => ({ value: id, label: nome })
);

export const getPedidoVooStatusLabel = (status) => {
  if (status === 'RESTRICAO_AREA') return 'Negado';
  const found = PEDIDO_VOO_STATUS[status];
  return found ? found.label : status;
};
